import Plyr from 'plyr';

const components = document.querySelectorAll('[data-component="Video"]');

components.forEach(component => {
  new Plyr(component.querySelector('.plyr-player'), {iconUrl: 'images/plyr.svg'});
})